import AddonsSelector from './AddonsSelector';
import { ADDON_LIST, getAddonPrices } from './addons';
import { usePricing } from './usePricing';
import React, { useState } from 'react';
import AvailabilityCalendar from './AvailabilityCalendar';

const API = 'https://api.botanix.in/api';

const C = {
 bg:'#0A1628', surface:'#0F2040', surface2:'#0F2040',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 accent:'#3AAF58', blue:'#FFFFFF',
 red:'#E05050', redBg:'rgba(224,80,80,.10)', redBorder:'rgba(224,80,80,.25)',
 amber:'#D4840F', amberBg:'rgba(212,132,15,.10)', amberBorder:'rgba(212,132,15,.25)',
 green:'#3AAF58', greenBg:'rgba(58,175,88,.10)', greenBorder:'rgba(58,175,88,.25)',
 purple:'#8060C0',
};

const inr = n => '₹' + Number(n||0).toLocaleString('en-IN',{maximumFractionDigits:0});

// ── PACKAGES ──────────────────────────────────────────────────────────────────
const PACKAGES = [
 { id:'corp_std', name:'Corporate Day Picnic – Standard', rate:1800, gst:18, includes:'Welcome Drink, Breakfast, Buffet Lunch, Hi-Tea, Activities' },
 { id:'corp_prem', name:'Corporate Day Picnic – Premium', rate:2800, gst:18, includes:'All Standard + DJ, Conference Hall, AV Setup, Bonfire' },
 { id:'school', name:'School Picnic Package', rate:950, gst:5, includes:'Welcome Drink, Lunch, 3 Activities' },
 { id:'mice', name:'MICE Conference Package', rate:3500, gst:18, includes:'Hall, AV, 3 Meals, Team Activities' },
 { id:'custom', name:'Custom Package (Manual Rate)', rate:0, gst:18, includes:'Set your own rate per pax' },
];

// ── FOOD MENU ─────────────────────────────────────────────────────────────────
const CORP_MENU = {
 welcome_drink: {
 label:' Welcome Drink', rate:120,
 categories:[{name:'Options',items:['Jal Jeera','Nimbu Pani','Fresh Juice','Coconut Water','Aam Panna','Shikanji']}]
 },
 breakfast: {
 label:' Breakfast', rate:650,
 categories:[
 {name:'Main',items:['Puri Bhaji','Poha','Idli Vada Sambhar','Aloo Paratha','Bread Butter']},
 {name:'Sides',items:['Cornflakes with Milk','Cut Fruits','Juice','Tea & Coffee']},
 ]
 },
 lunch: {
 label:' Lunch', rate:950,
 categories:[
 {name:'Main Course',items:['Paneer Butter Masala','Dal Makhani','Mix Veg','Rajma Masala','Dum Aloo']},
 {name:'Rice & Bread',items:['Jeera Rice','Peas Pulao','Roti','Naan','Paratha']},
 {name:'Salad',items:['Fresh Salad','Raita','Achar','Papad']},
 {name:'Desserts',items:['Gulab Jamun','Ice Cream','Halwa']},
 ]
 },
 hi_tea: {
 label:' Hi-Tea', rate:350,
 categories:[
 {name:'Beverages',items:['Tea','Coffee']},
 {name:'Snacks',items:['Samosa','Pakora','Sandwich','Biscuits','Cake']},
 ]
 },
 dinner: {
 label:' Dinner', rate:1500,
 categories:[
 {name:'Starters',items:['Paneer Tikka','Hara Bhara Kebab','Chicken Tikka','Seekh Kebab']},
 {name:'Main Course',items:['Butter Chicken','Shahi Paneer','Dal Tadka','Mix Veg','Kadai Paneer']},
 {name:'Rice & Bread',items:['Biryani','Jeera Rice','Naan','Roti']},
 {name:'Desserts',items:['Gulab Jamun','Ice Cream','Kheer']},
 ]
 },
 buffet_veg: {
 label:' Buffet Lunch – Veg', rate:650,
 categories:[{name:'Buffet Items',items:['Paneer Dish','Dal','Mix Veg','Rice','Roti','Salad','Dessert']}]
 },
 buffet_nonveg: {
 label:' Buffet Lunch – Non-Veg', rate:850,
 categories:[{name:'Buffet Items',items:['Chicken Dish','Paneer Dish','Dal','Mix Veg','Rice','Roti','Salad','Dessert']}]
 },
};

// ── ADD-ONS ───────────────────────────────────────────────────────────────────
// ADDON_LIST imported from addons.js


const inp = { width:'100%', padding:'10px 12px', background:'#22263A', border:'1px solid rgba(255,255,255,.14)', borderRadius:8, color:'#F0F2FF', fontSize:14, boxSizing:'border-box', outline:'none' };
const sel = { ...inp, cursor:'pointer' };

// ── FOOD MODAL ────────────────────────────────────────────────────────────────
function FoodModal({ mealKey, selected, onSave, onClose }) {
 const menu = CORP_MENU[mealKey];
 const [selItems, setSelItems] = useState(selected || []);
 const toggle = item => setSelItems(p => p.includes(item) ? p.filter(x=>x!==item) : [...p, item]);
 return (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.88)', zIndex:2000, display:'flex', alignItems:'flex-start', justifyContent:'center', padding:16, overflowY:'auto' }}>
 <div style={{ background:'#1A1D27', border:'1px solid rgba(255,255,255,.14)', borderRadius:16, width:'100%', maxWidth:600, marginTop:20, marginBottom:20 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 22px', borderBottom:'1px solid rgba(255,255,255,.08)', background:'linear-gradient(135deg,#192D1F,#1A2E1A)', borderRadius:'16px 16px 0 0' }}>
 <div>
 <div style={{ fontWeight:800, fontSize:15, color:'#fff' }}>{menu.label} — Food Selection</div>
 <div style={{ fontSize:11, color:'rgba(255,255,255,.4)', marginTop:2 }}>{selItems.length} items selected</div>
 </div>
 <button onClick={onClose} style={{ background:'none', border:'none', color:'rgba(255,255,255,.5)', fontSize:20, cursor:'pointer' }}></button>
 </div>
 <div style={{ padding:20, maxHeight:'60vh', overflowY:'auto' }}>
 {menu.categories.map((cat,i) => (
 <div key={i} style={{ marginBottom:14 }}>
 <div style={{ fontSize:12, fontWeight:700, color:C.amber, marginBottom:8, textTransform:'uppercase', letterSpacing:'.06em' }}>{cat.name}</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:5 }}>
 {cat.items.map((item,j) => {
 const isSel = selItems.includes(item);
 return (
 <div key={j} onClick={() => toggle(item)}
 style={{ padding:'7px 10px', background:isSel?`${C.accent}18`:C.surface2, border:`1px solid ${isSel?C.accent:C.border}`, borderRadius:7, cursor:'pointer', display:'flex', alignItems:'center', gap:7 }}>
 <div style={{ width:15, height:15, borderRadius:4, background:isSel?C.accent:'transparent', border:`2px solid ${isSel?C.accent:C.border2}`, flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:10, color:'#fff' }}>
 {isSel?'':''}
 </div>
 <span style={{ fontSize:12, color:isSel?C.text:C.text2 }}>{item}</span>
 </div>
 );
 })}
 </div>
 </div>
 ))}
 </div>
 <div style={{ display:'flex', justifyContent:'space-between', padding:'14px 22px', borderTop:'1px solid rgba(255,255,255,.08)', alignItems:'center' }}>
 <div style={{ fontSize:13, color:C.text2 }}>{selItems.length} items selected</div>
 <div style={{ display:'flex', gap:8 }}>
 <button onClick={onClose} style={{ padding:'9px 18px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>Cancel</button>
 <button onClick={() => { onSave(selItems); onClose(); }} style={{ padding:'9px 22px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700 }}>Save</button>
 </div>
 </div>
 </div>
 </div>
 );
}

// ── MAIN FORM ─────────────────────────────────────────────────────────────────
export default function CorporateBooking({ onClose, onSave, bookingToEdit }) {
 const currentUser = (() => { try { return JSON.parse(localStorage.getItem('botanix_user')); } catch { return null; } })();
 const roleKey = currentUser?.roleKey || '';
 const isSuperAdmin = roleKey === 'SUPER_ADMIN';
 const isSales = roleKey === 'SALES';
 const { rates: pricingRates, rules: pricingRules, loading: pricingLoading } = usePricing();
 const isSalesDirector = currentUser?.name === 'Sonam Vashisth' || isSuperAdmin;
 const maxDiscount = isSuperAdmin ? 100 : isSalesDirector ? 12 : 5;
 const isEdit = !!bookingToEdit;

 const [step, setStep] = useState(1);
 const [saving, setSaving] = useState(false);
 const [error, setError] = useState('');

 // Guest
 const [guestName, setGuestName] = useState(bookingToEdit?.guest_name || '');
 const [guestPhone, setGuestPhone] = useState(bookingToEdit?.guest_phone || '');
 const [guestEmail, setGuestEmail] = useState(bookingToEdit?.guest_email || '');
 const [company, setCompany] = useState('');
 const [gstNum, setGstNum] = useState('');

 // Event
 const [eventDate, setEventDate] = useState(bookingToEdit?.start_date?.slice(0,10) || '');
 const [endDate, setEndDate] = useState(bookingToEdit?.end_date?.slice(0,10) || '');
 const [pax, setPax] = useState(100);
 const [bookingType, setBookingType] = useState(' Corporate / MICE');
 const [status, setStatus] = useState('Confirmed');
 const [salesperson, setSalesperson] = useState(bookingToEdit?.salesperson || currentUser?.name || '');
 const [source, setSource] = useState('Direct');
 const [notes, setNotes] = useState('');

 // Package
 const [selPackage, setSelPackage] = useState('corp_std');
 const [customRate, setCustomRate] = useState(0);

 // Meals
 const [meals, setMeals] = useState({});
 const [foodModal, setFoodModal] = useState(null);

 const toggleMeal = (mealKey) => {
 const menu = CORP_MENU[mealKey];
 if (meals[mealKey]) { const m={...meals}; delete m[mealKey]; setMeals(m); }
 else setMeals(p => ({...p, [mealKey]:{pax, food_items:[], rate:menu.rate}}));
 };
 const updateMealPax = (key, p) => setMeals(prev => ({...prev, [key]:{...prev[key],pax:parseInt(p)||1}}));
 const updateMealRate = (key, r) => setMeals(prev => ({...prev, [key]:{...prev[key],rate:parseFloat(r)||0}}));
 const updateMealFood = (key, items) => setMeals(prev => ({...prev, [key]:{...prev[key],food_items:items}}));

 // Add-ons
 const [addons, setAddons] = useState(
 ADDON_LIST.reduce((acc, a) => ({ ...acc, [a.id]: { enabled:false, price:'', qty:1, note:'' } }), {})
 );
 const updateAddon = (id, field, value) => setAddons(p => ({ ...p, [id]: { ...p[id], [field]: value } }));

 // Pricing
 const [discountPct, setDiscountPct] = useState(0);
 const [manualTotal, setManualTotal] = useState('');
 const [useManualTotal, setUseManualTotal] = useState(false);
 const [advance, setAdvance] = useState(0);

 // Restore on edit
 React.useEffect(() => {
 if (!bookingToEdit) return;
 try {
 const raw = bookingToEdit.notes || '';
 const match = raw.match(/<<<CORP_DATA:(.*?)>>>/s);
 if (match) {
 const d = JSON.parse(match[1]);
 if (d.pax) setPax(d.pax);
 if (d.selPackage) setSelPackage(d.selPackage);
 if (d.customRate) setCustomRate(d.customRate);
 if (d.meals) setMeals(d.meals);
 if (d.addons) setAddons(d.addons);
 if (d.discountPct) setDiscountPct(d.discountPct);
 if (d.advance) setAdvance(d.advance);
 if (d.manualTotal) { setManualTotal(d.manualTotal); setUseManualTotal(true); }
 if (d.company) setCompany(d.company);
 if (d.gstNum) setGstNum(d.gstNum);
 if (d.notes) setNotes(d.notes);
 if (d.bookingType) setBookingType(d.bookingType);
 if (d.status) setStatus(d.status);
 }
 } catch(e) {}
 }, []);

 // ── CALCULATE ─────────────────────────────────────────────────────────────
 const calcBreakdown = () => {
 const bd = [];
 let subtotal = 0;

 // Package
 const pkg = PACKAGES.find(p => p.id === selPackage);
 if (pkg) {
 const rate = selPackage === 'custom' ? parseFloat(customRate)||0 : pkg.rate;
 if (rate > 0) {
 const amt = rate * pax;
 bd.push({ label:`${pkg.name} × ${pax} pax`, amount:amt });
 subtotal += amt;
 }
 }

 // Additional meals
 Object.entries(meals).forEach(([key, md]) => {
 const menu = CORP_MENU[key];
 if (!menu) return;
 const rate = md.rate || menu.rate;
 const mpax = md.pax || pax;
 const amt = rate * mpax;
 const food = md.food_items?.length>0 ? ` (${md.food_items.length} items)` : '';
 bd.push({ label:`${menu.label} × ${mpax} pax${food}`, amount:amt });
 subtotal += amt;
 });

 // Add-ons
 ADDON_LIST.forEach(addon => {
 const ad = addons[addon.id];
 if (ad?.enabled && ad?.price) {
 const amt = parseFloat(ad.price) * (parseInt(ad.qty)||1);
 bd.push({ label:`${addon.name}${ad.qty>1?` × ${ad.qty}`:''}`, amount:amt });
 subtotal += amt;
 }
 });

 const discAmt = Math.round(subtotal * discountPct / 100);
 return { bd, subtotal, discAmt, calcTotal: subtotal - discAmt };
 };

 const { bd: breakdown, subtotal, discAmt, calcTotal } = calcBreakdown();
 const finalTotal = useManualTotal && manualTotal ? parseFloat(manualTotal) : calcTotal;
 const approvalRequired = discountPct > maxDiscount;
 const enabledAddons = ADDON_LIST.filter(a => addons[a.id]?.enabled);

 const handleSave = async () => {
 if (!guestName.trim()) { setError('Enter client/company name'); return; }
 if (!eventDate) { setError('Select event date'); return; }
 if (approvalRequired) { setError(`Discount above ${maxDiscount}% requires Super Admin approval`); return; }
 setSaving(true); setError('');
 try {
 const bdText = breakdown.map(b=>`${b.label}: ${inr(b.amount)}`).join('\n');
 const method = isEdit ? 'PUT' : 'POST';
 const url = isEdit ? `${API}/bookings/${bookingToEdit.id}` : `${API}/bookings`;
 const res = await fetch(url, {
 method, headers:{'Content-Type':'application/json'},
 body: JSON.stringify({
 guest_name:guestName, guest_phone:guestPhone, guest_email:guestEmail,
 booking_type: bookingType,
 start_date:eventDate, end_date:endDate||eventDate,
 pax_count:pax, booking_status:status,
 total_amount:finalTotal, advance_paid:advance, balance_amount:finalTotal-advance,
 salesperson, source, discount_pct:discountPct,
 notes:`<<<CORP_DATA:${JSON.stringify({pax,selPackage,customRate,meals,addons,discountPct,advance,manualTotal,company,gstNum,notes,bookingType,status})}>>>\nCorporate Booking\nCompany: ${company||guestName}\nPax: ${pax}\n\nCOST BREAKDOWN:\n${bdText}\n\nSubtotal: ${inr(subtotal)}\nDiscount ${discountPct}%: -${inr(discAmt)}\nFINAL TOTAL: ${inr(finalTotal)}\n\n${notes}`,
 }),
 });
 const data = await res.json();
 if (!res.ok) throw new Error(data.error||'Failed');
 onSave(); onClose();
 } catch(err) { setError(err.message); }
 finally { setSaving(false); }
 };

 const BOOKING_TYPES = [' Corporate / MICE',' Day Picnic',' School Picnic',' Room Stay',' Event / Wedding'];
 const STATUSES = ['Confirmed','Tentative','Cancelled','Checked In','Checked Out'];

 const STEPS = [
 {n:1,l:'1. Calendar & Client'},
 {n:2,l:'2. Package & Food'},
 {n:3,l:'3. Add-ons'},
 {n:4,l:'4. Pricing & Confirm'},
 ];

 return (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.78)', zIndex:1000, display:'flex', alignItems:'flex-start', justifyContent:'center', padding:16, overflowY:'auto' }}>
 <div style={{ background:'#1A1D27', border:'1px solid rgba(255,255,255,.14)', borderRadius:16, width:'100%', maxWidth:960, marginTop:20, marginBottom:20 }}>

 {/* Header */}
 <div style={{ padding:'16px 24px', background:'linear-gradient(135deg,#0A1A2E,#102040)', borderRadius:'16px 16px 0 0', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
 <div>
 <div style={{ fontWeight:900, fontSize:17, color:'#fff' }}> {isEdit?'Edit':'New'} Corporate / Day Picnic Booking</div>
 <div style={{ fontSize:12, color:'rgba(255,255,255,.5)', marginTop:2 }}>With food selection, add-ons & availability calendar</div>
 </div>
 <div style={{ display:'flex', gap:10, alignItems:'center' }}>
 <div style={{ fontSize:16, fontWeight:800, color:C.accent }}>{inr(finalTotal)}</div>
 <button onClick={onClose} style={{ background:'none', border:'none', color:'rgba(255,255,255,.5)', fontSize:20, cursor:'pointer' }}></button>
 </div>
 </div>

 {/* Step tabs */}
 <div style={{ display:'flex', gap:0, padding:'0 24px', borderBottom:'1px solid rgba(255,255,255,.08)', flexWrap:'wrap' }}>
 {STEPS.map(s=>(
 <button key={s.n} onClick={()=>s.n<=step?setStep(s.n):null}
 style={{ padding:'11px 18px', background:'transparent', border:'none', borderBottom:`2px solid ${step===s.n?C.accent:'transparent'}`, color:step===s.n?C.accent:step>s.n?C.text2:C.text3, cursor:'pointer', fontSize:13, fontWeight:600, whiteSpace:'nowrap' }}>
 {s.l}
 </button>
 ))}
 </div>

 <div style={{ padding:24 }}>
 {error && <div style={{ padding:'10px 14px', background:C.redBg, border:`1px solid ${C.redBorder}`, borderRadius:8, color:C.red, fontSize:13, marginBottom:16 }}>{error}</div>}

 {/* ── STEP 1: Calendar & Client ── */}
 {step===1 && (
 <div>
 <AvailabilityCalendar onDateSelect={date=>setEventDate(date)} selectedDate={eventDate} />

 <div style={{ fontWeight:700, fontSize:13, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}>Client / Company Details</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:20 }}>
 <div style={{ gridColumn:'span 2' }}>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Company / Client Name *</label>
 <input style={inp} type="text" value={guestName} onChange={e=>setGuestName(e.target.value)} placeholder="e.g. Infosys Ltd — Annual Day Picnic" />
 </div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Contact Person</label><input style={inp} type="text" value={company} onChange={e=>setCompany(e.target.value)} placeholder="HR Manager name" /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Phone</label><input style={inp} type="text" value={guestPhone} onChange={e=>setGuestPhone(e.target.value)} /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Email</label><input style={inp} type="email" value={guestEmail} onChange={e=>setGuestEmail(e.target.value)} /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>GST Number</label><input style={inp} type="text" value={gstNum} onChange={e=>setGstNum(e.target.value)} /></div>
 </div>

 <div style={{ fontWeight:700, fontSize:13, color:C.text2, marginBottom:12, textTransform:'uppercase', letterSpacing:'.05em' }}>Event Details</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Event Date * {eventDate && <span style={{color:C.accent}}>— {new Date(eventDate).toLocaleDateString('en-IN',{weekday:'long',day:'numeric',month:'long'})}</span>}</label>
 <input style={inp} type="date" value={eventDate} onChange={e=>setEventDate(e.target.value)} />
 </div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>End Date (if overnight)</label><input style={inp} type="date" value={endDate} onChange={e=>setEndDate(e.target.value)} /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Number of Pax *</label><input style={inp} type="number" min={1} value={pax} onChange={e=>setPax(parseInt(e.target.value)||1)} /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Booking Type</label>
 <select style={sel} value={bookingType} onChange={e=>setBookingType(e.target.value)}>
 {BOOKING_TYPES.map(t=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={t}>{t}</option>)}
 </select>
 </div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Status</label>
 <select style={sel} value={status} onChange={e=>setStatus(e.target.value)}>
 {STATUSES.map(s=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={s}>{s}</option>)}
 </select>
 </div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Source</label>
 <select style={sel} value={source} onChange={e=>setSource(e.target.value)}>
 {['Direct','Travel Agent','Corporate','Referral','Website','WhatsApp','OTA','Cold Call'].map(s=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={s}>{s}</option>)}
 </select>
 </div>
 <div style={{ gridColumn:'span 2' }}><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Salesperson</label><input style={{...inp, opacity: isSales?0.7:1}} type="text" value={salesperson} onChange={e=>!isSales&&setSalesperson(e.target.value)} readOnly={isSales} /></div>
 </div>
 </div>
 )}

 {/* ── STEP 2: Package & Food ── */}
 {step===2 && (
 <div>
 {/* Package Selection */}
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:12 }}> Select Package</div>
 <div style={{ display:'grid', gap:8, marginBottom:20 }}>
 {PACKAGES.map(pkg => (
 <div key={pkg.id} onClick={()=>setSelPackage(pkg.id)}
 style={{ padding:14, background:selPackage===pkg.id?`${C.accent}12`:C.surface2, border:`1px solid ${selPackage===pkg.id?C.accent:C.border}`, borderRadius:10, cursor:'pointer' }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
 <div>
 <div style={{ fontWeight:700, fontSize:13, color:C.text, marginBottom:3 }}>{pkg.name}</div>
 <div style={{ fontSize:11, color:C.text3 }}>{pkg.includes}</div>
 </div>
 <div style={{ textAlign:'right', flexShrink:0, marginLeft:10 }}>
 {pkg.id !== 'custom'
 ? <><div style={{ fontWeight:800, fontSize:16, color:C.accent }}>{inr(pkg.rate)}/pax</div>
 <div style={{ fontSize:11, color:C.text3 }}>= {inr(pkg.rate*pax)}</div></>
 : <div style={{ fontSize:12, color:C.amber }}>Enter rate below</div>
 }
 </div>
 </div>
 {selPackage===pkg.id && pkg.id==='custom' && (
 <div style={{ marginTop:10 }}>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Custom Rate per Pax (₹)</label>
 <input style={inp} type="number" value={customRate} onChange={e=>setCustomRate(e.target.value)} placeholder="Enter negotiated rate" onClick={e=>e.stopPropagation()} />
 {customRate > 0 && <div style={{ fontSize:11, color:C.accent, marginTop:4 }}>Total: {inr(parseFloat(customRate)*pax)}</div>}
 </div>
 )}
 </div>
 ))}
 </div>

 {/* Additional Meals */}
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:6 }}> Additional Meals (outside package)</div>
 <div style={{ fontSize:12, color:C.text3, marginBottom:12 }}>Add meals not included in the package, or if client wants extras</div>
 <div style={{ display:'grid', gap:8 }}>
 {Object.entries(CORP_MENU).map(([key, menu]) => {
 const mealData = meals[key];
 const isSel = !!mealData;
 return (
 <div key={key} style={{ background:isSel?`${C.accent}10`:C.surface2, border:`1px solid ${isSel?C.accent:C.border}`, borderRadius:10, padding:10 }}>
 <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:isSel?8:0 }}>
 <button onClick={()=>toggleMeal(key)}
 style={{ width:20, height:20, borderRadius:5, background:isSel?C.accent:'transparent', border:`2px solid ${isSel?C.accent:C.border2}`, cursor:'pointer', color:'#fff', fontSize:10, flexShrink:0 }}>
 {isSel?'':''}
 </button>
 <div style={{ flex:1 }}>
 <span style={{ fontSize:13, fontWeight:600, color:C.text }}>{menu.label}</span>
 <span style={{ fontSize:11, color:C.accent, marginLeft:8 }}>{inr(menu.rate)}/pax</span>
 </div>
 {isSel && <div style={{ fontSize:13, fontWeight:700, color:C.accent }}>{inr((mealData.rate||menu.rate)*(mealData.pax||pax))}</div>}
 </div>
 {isSel && (
 <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap', paddingLeft:30 }}>
 <div style={{ display:'flex', alignItems:'center', gap:6 }}>
 <label style={{ fontSize:11, color:C.text3 }}>Pax:</label>
 <input type="number" min={1} value={mealData.pax||pax} onChange={e=>updateMealPax(key,e.target.value)}
 style={{ ...inp, width:75, padding:'4px 8px', fontSize:12 }} />
 </div>
 <div style={{ display:'flex', alignItems:'center', gap:6 }}>
 <label style={{ fontSize:11, color:C.text3 }}>Rate ₹:</label>
 <input type="number" min={0} value={mealData.rate||menu.rate} onChange={e=>updateMealRate(key,e.target.value)}
 style={{ ...inp, width:90, padding:'4px 8px', fontSize:12 }} />
 </div>
 <button onClick={()=>setFoodModal(key)}
 style={{ padding:'4px 12px', background:mealData.food_items?.length>0?`${C.accent}20`:'rgba(255,255,255,.06)', border:`1px solid ${mealData.food_items?.length>0?C.accent:C.border2}`, borderRadius:6, color:mealData.food_items?.length>0?C.accent:C.text2, cursor:'pointer', fontSize:11, fontWeight:600 }}>
 {mealData.food_items?.length>0?`${mealData.food_items.length} items`:'Select Items'}
 </button>
 </div>
 )}
 </div>
 );
 })}
 </div>
 </div>
 )}

 {/* ── STEP 3: Add-ons ── */}
 {step===3 && (
 <div>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:6 }}> Add-ons & Services</div>
 <div style={{ fontSize:12, color:C.text3, marginBottom:16 }}>Enter negotiated price for each add-on.</div>
 <div style={{ display:'grid', gap:8 }}>
 {ADDON_LIST.map(addon => {
 const ad = addons[addon.id];
 const isEnabled = ad?.enabled;
 const total = isEnabled && ad?.price ? parseFloat(ad.price)*(parseInt(ad.qty)||1) : 0;
 return (
 <div key={addon.id} style={{ background:isEnabled?`${C.accent}10`:C.surface2, border:`1px solid ${isEnabled?C.accent:C.border}`, borderRadius:10, padding:10 }}>
 <div style={{ display:'flex', alignItems:'center', gap:10 }}>
 <button onClick={()=>updateAddon(addon.id,'enabled',!isEnabled)}
 style={{ width:20, height:20, borderRadius:5, background:isEnabled?C.accent:'transparent', border:`2px solid ${isEnabled?C.accent:C.border2}`, cursor:'pointer', color:'#fff', fontSize:10, flexShrink:0 }}>
 {isEnabled?'':''}
 </button>
 <div style={{ fontSize:18, flexShrink:0 }}>{addon.icon}</div>
 <div style={{ flex:1 }}>
 <div style={{ fontSize:13, fontWeight:600, color:C.text }}>{addon.name}</div>
 <div style={{ fontSize:11, color:C.text3 }}>{addon.unit}</div>
 </div>
 {isEnabled && (
 <>
 <div style={{ display:'flex', alignItems:'center', gap:4 }}>
 <span style={{ fontSize:11, color:C.text3 }}>₹</span>
 <input type="number" min={0} value={ad.price} onChange={e=>updateAddon(addon.id,'price',e.target.value)}
 placeholder="Price" style={{ ...inp, width:110, padding:'5px 8px', fontSize:13 }} />
 </div>
 {(addon.unit.includes('unit')||addon.unit.includes('day')) && (
 <div style={{ display:'flex', alignItems:'center', gap:4 }}>
 <span style={{ fontSize:11, color:C.text3 }}>Qty</span>
 <input type="number" min={1} value={ad.qty||1} onChange={e=>updateAddon(addon.id,'qty',e.target.value)}
 style={{ ...inp, width:55, padding:'5px 8px', fontSize:13 }} />
 </div>
 )}
 {total>0 && <div style={{ fontSize:13, fontWeight:700, color:C.accent, flexShrink:0 }}>{inr(total)}</div>}
 </>
 )}
 </div>
 {isEnabled && (
 <div style={{ paddingLeft:58, marginTop:6 }}>
 <input type="text" value={ad.note||''} onChange={e=>updateAddon(addon.id,'note',e.target.value)}
 placeholder="Note (optional)" style={{ ...inp, padding:'5px 10px', fontSize:12 }} />
 </div>
 )}
 </div>
 );
 })}
 </div>
 {enabledAddons.length>0 && (
 <div style={{ marginTop:14, padding:'10px 14px', background:`${C.purple}15`, border:'1px solid rgba(128,96,192,.3)', borderRadius:8, fontSize:13, color:C.purple }}>
 {enabledAddons.length} add-on(s) · Add-on total: <strong>{inr(ADDON_LIST.filter(a=>addons[a.id]?.enabled&&addons[a.id]?.price).reduce((s,a)=>s+parseFloat(addons[a.id].price||0)*(parseInt(addons[a.id].qty)||1),0))}</strong>
 </div>
 )}
 </div>
 )}

 {/* ── STEP 4: Pricing ── */}
 {step===4 && (
 <div>
 {/* Breakdown */}
 <div style={{ background:C.surface2, borderRadius:12, padding:16, marginBottom:14 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:12 }}> Cost Breakdown</div>
 <div style={{ maxHeight:240, overflowY:'auto' }}>
 {breakdown.map((b,i)=>(
 <div key={i} style={{ display:'flex', justifyContent:'space-between', fontSize:13, padding:'6px 0', borderBottom:'1px solid rgba(255,255,255,.04)', color:C.text2 }}>
 <span>{b.label}</span><span style={{ fontWeight:600, color:C.text, flexShrink:0, marginLeft:10 }}>{inr(b.amount)}</span>
 </div>
 ))}
 {breakdown.length===0 && <div style={{ color:C.text3, fontSize:13 }}>No items selected yet</div>}
 </div>
 <div style={{ borderTop:`1px solid ${C.border}`, paddingTop:10, marginTop:8 }}>
 <div style={{ display:'flex', justifyContent:'space-between', fontSize:14, fontWeight:700, color:C.text, marginBottom:4 }}><span>Subtotal</span><span>{inr(subtotal)}</span></div>
 {discountPct>0 && <div style={{ display:'flex', justifyContent:'space-between', fontSize:13, color:C.amber, marginBottom:4 }}><span>Discount ({discountPct}%)</span><span>- {inr(discAmt)}</span></div>}
 <div style={{ display:'flex', justifyContent:'space-between', fontSize:20, fontWeight:900, color:C.accent, borderTop:`1px solid ${C.border}`, paddingTop:8, marginTop:4 }}>
 <span>Total (GST Extra)</span><span>{inr(useManualTotal&&manualTotal?parseFloat(manualTotal):calcTotal)}</span>
 </div>
 </div>
 </div>

 {/* Discount */}
 <div style={{ background:C.surface2, borderRadius:12, padding:16, marginBottom:14 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:12 }}>
 Discount <span style={{ fontSize:11, color:C.text3, fontWeight:400 }}>Your limit: {maxDiscount}% ({isSalesDirector?'Sales Director':isSuperAdmin?'Admin':'Sales Team'})</span>
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Discount %</label>
 <input style={inp} type="number" min={0} max={isSuperAdmin?100:maxDiscount} value={discountPct} onChange={e=>setDiscountPct(parseFloat(e.target.value)||0)} /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Discount Amount</label>
 <div style={{ padding:'10px 12px', background:'#22263A', border:'1px solid rgba(255,255,255,.14)', borderRadius:8, color:C.amber, fontSize:14, fontWeight:700 }}>{inr(discAmt)}</div></div>
 </div>
 {approvalRequired && <div style={{ marginTop:10, padding:'10px 14px', background:C.amberBg, border:`1px solid ${C.amberBorder}`, borderRadius:8, color:C.amber, fontSize:13 }}> Discount above {maxDiscount}% requires Super Admin approval.</div>}
 </div>

 {/* Manual Override */}
 <div style={{ background:C.surface2, borderRadius:12, padding:16, marginBottom:14 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:useManualTotal?12:0 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text }}> Manual Rate (Round-off)</div>
 <label style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer' }}>
 <input type="checkbox" checked={useManualTotal} onChange={e=>setUseManualTotal(e.target.checked)} />
 <span style={{ fontSize:12, color:C.text2 }}>Override with manual total</span>
 </label>
 </div>
 {useManualTotal && (
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Final Amount (₹)</label>
 <input style={inp} type="number" value={manualTotal} onChange={e=>setManualTotal(e.target.value)} placeholder={`Calculated: ${inr(calcTotal)}`} />
 </div>
 )}
 </div>

 {/* Advance */}
 <div style={{ background:C.surface2, borderRadius:12, padding:16, marginBottom:14 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:12 }}> Advance Payment</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Advance Paid (₹)</label>
 <input style={inp} type="number" min={0} value={advance} onChange={e=>setAdvance(parseFloat(e.target.value)||0)} /></div>
 <div><label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Balance Due</label>
 <div style={{ padding:'10px 12px', background:'#22263A', border:'1px solid rgba(255,255,255,.14)', borderRadius:8, color:C.red, fontSize:14, fontWeight:700 }}>{inr(finalTotal-advance)}</div></div>
 </div>
 </div>

 {/* Notes */}
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Notes / Special Requirements</label>
 <textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Special requirements, dietary restrictions, parking, transport..."
 style={{ ...inp, height:80, resize:'vertical' }} />
 </div>
 </div>
 )}
 </div>

 {/* Footer */}
 <div style={{ display:'flex', justifyContent:'space-between', padding:'16px 24px', borderTop:'1px solid rgba(255,255,255,.08)' }}>
 <div>{step>1 && <button onClick={()=>setStep(s=>s-1)} style={{ padding:'10px 20px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer', fontSize:14 }}>← Back</button>}</div>
 <div style={{ display:'flex', gap:10, alignItems:'center' }}>
 {step===4 && <div style={{ fontSize:16, fontWeight:900, color:C.accent }}>{inr(finalTotal)}</div>}
 <button onClick={onClose} style={{ padding:'10px 20px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer', fontSize:14 }}>Cancel</button>
 {step<4
 ? <button onClick={()=>{
 if(step===1&&!guestName.trim()){setError('Enter client name');return;}
 if(step===1&&!eventDate){setError('Select event date');return;}
 setError('');setStep(s=>s+1);
 }} style={{ padding:'10px 24px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:14, fontWeight:700 }}>Next →</button>
 : <button onClick={handleSave} disabled={saving||approvalRequired}
 style={{ padding:'10px 24px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:14, fontWeight:700, opacity:(saving||approvalRequired)?.6:1 }}>
 {saving?'Saving…':isEdit?' Save Changes':' Confirm Booking'}
 </button>
 }
 </div>
 </div>
 </div>

 {foodModal && <FoodModal mealKey={foodModal} selected={meals[foodModal]?.food_items||[]} onSave={items=>updateMealFood(foodModal,items)} onClose={()=>setFoodModal(null)} />}
 </div>
 );
}
